import React from 'react';
import './SearchResultsContainer.css';
import ResultCardList from './ResultCardList';
import Pagination from './Pagination';


function SearchResultsContainer({ items,
    query,
    originalQuery,
    selectedFeature,
    aiSearchMode,
    accordionInfo,
    fromPosition,
    maxResults,
    handleNextPage,
    handlePreviousPage,
    showPagination,
    handleReset,
}) {
    return (
        <div className='search-results-content'>
            <ResultCardList
                title={query}
                items={items}
                originalQuery={originalQuery}
                selectedFeature={selectedFeature}
                aiSearchMode={aiSearchMode}
                accordionInfo={accordionInfo}
            />
            {showPagination && (<Pagination
                fromPos={fromPosition}
                maxResults={maxResults}
                onPrevious={handlePreviousPage}
                onNext={handleNextPage}
                hasResults={items.length}
            />)}
            <div className="reset-btn" onClick={handleReset}>reset</div>
        </div>
    );
}

export default SearchResultsContainer;